// 小數點無條件捨去到 index定幾位數
export const ToDecimal = function (num, index = 2) {
  if (isNaN(num)) return
  const newnum = num.toString()
  const snum = newnum.split('.')
  let buz = ''
  if (snum[1] === undefined) {
    buz = Array.from({ length: index }, () => '0').join('')
  } else {
    const arr = snum[1].split('')
    for (let i = 0; i < index; i++) {
      buz += arr[i] ? arr[i] : '0'
    }
  }
  return snum[0] + '.' + buz
}
// 數字千分位
export const cFormat = function (value) {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function formatCurrency (currency, hasDecimal = true) {
  if (!currency) return '0.00'
  const parts = currency.toString().split('.')
  parts[0] = cFormat(parts[0])
  return hasDecimal ? cFormat(ToDecimal(currency)) : parts.join('.')
}
